import Repository from './repository';

const repository = new Repository();

let bytter = []
function HentBytter(callback, token) {        
    if (!token){ //Nullstill array første gang, men ikke dersom det er paging?
        bytter = []
    }

    repository.hentBytter(token).then(response => {
        const continuation = response.m_Item1;
        const data = response.m_Item2;
        
        bytter = bytter.concat(data);
        if (continuation) {
            HentBytter(callback, continuation);
        } else {
            callback(bytter);
        }
    }).catch(err => {
        console.error(err);
    });
}


export { HentBytter }



// WEBPACK FOOTER //
// ./src/felles/tablestorageRepository.js